import PropertiesListPageContainer from './containers/PropertiesListPageContainer'

export default PropertiesListPageContainer
